import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { PrimaryButton } from '@fluentui/react';
import {buttonStyle} from '../styles/HomeScreen.styles';

export const SignInButton = () => {
    const { instance } = useMsal();

    const handleLogin = (loginType: string) => {
        if (loginType === "popup") {
            instance.loginPopup(loginRequest);
        } else if (loginType === "redirect") {
            // Try to capture a meetingId from current URL or sessionStorage and pass it in state
            try {
                const params = new URLSearchParams(window.location.search);
                const meetingId = params.get('meetingId') || sessionStorage.getItem('incomingMeetingId');
                if (meetingId) {
                    instance.loginRedirect({
                        ...loginRequest,
                        state: JSON.stringify({ meetingId }),
                    });
                    return;
                }
            } catch (e) {
                // ignore and fallback to default
            }

            instance.loginRedirect(loginRequest);
        }
    }

    return (
        <div>
            <PrimaryButton onClick={() => handleLogin("redirect")} className={buttonStyle}>Sign In</PrimaryButton>
        </div>
    )
}